import React, { useCallback, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import FilterList from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import ProcessIndicator from "../../components/ProcessIndicator/ProcessIndicator";
import { useAppDispatch } from "@/store/store";
import { processingStateTypes } from "../../functions/constants";
import { useIntl } from "react-intl";
import { ticketListActions } from "../../modules/ticket/ticketList/ticketListSlice";

// Functional refactor of the previous class-based component. Keeps behavior identical
// while removing unused state (auth) and leveraging hooks for simplicity & clarity.
const TicketFilterMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  const open = Boolean(anchorEl);

  const handleMenu = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => setAnchorEl(null), []);

  const applyFilter = useCallback(
    (processingStateId) => {
      dispatch(ticketListActions.setTicketListFilter(processingStateId));
    },
    [dispatch],
  );

  const menuItemStyle = { justifyContent: "flex-end" };

  return (
    <div>
      <IconButton
        aria-label={formatMessage({
          id: "ticket.filter.button.label",
          defaultMessage: "Filter tickets",
        })}
        aria-controls={open ? "ticket-filter-menu" : undefined}
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        size="large"
      >
        <FilterList />
      </IconButton>
      <Menu
        id="ticket-filter-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          style={menuItemStyle}
          onClick={() => {
            applyFilter("ALL");
            handleClose();
          }}
        >
          {formatMessage({ id: "ticket.filter.option.no_filter" })}
        </MenuItem>
        {processingStateTypes.map((type) => (
          <MenuItem
            style={menuItemStyle}
            key={type.id}
            onClick={() => {
              applyFilter(type.id);
              handleClose();
            }}
          >
            <ProcessIndicator status={type.id} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default React.memo(TicketFilterMenu);
